import { render, staticRenderFns } from "./NewInputPeopleNum.vue?vue&type=template&id=1380bbb2&scoped=true"
import script from "./NewInputPeopleNum.vue?vue&type=script&lang=js"
export * from "./NewInputPeopleNum.vue?vue&type=script&lang=js"
import style0 from "./NewInputPeopleNum.vue?vue&type=style&index=0&id=1380bbb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380bbb2",
  null
  
)

export default component.exports